import React from 'react';
import { FaInstagram, FaFacebookF, FaYoutube, FaTiktok, FaTwitter, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import Logo from "../Assest/images/logo.png"; // Assuming this is the correct path to your logo
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-b from-gray-900 to-black pt-16 sm:pt-20 pb-10 overflow-hidden">
      {/* Enhanced Decorative Gradient */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] sm:w-[600px] h-[400px] sm:h-[600px] rounded-full bg-[#f36812]/10 blur-[100px] sm:blur-[150px] -z-0"
        style={{ background: 'radial-gradient(circle, rgba(243,104,18,0.2) 0%, rgba(0,0,0,0) 70%)' }}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 sm:gap-12 mb-12 sm:mb-16">
          {/* Brand Section */}
          <div className="lg:col-span-4">
            <div className="flex items-center mb-6">
              <img
                src={Logo}
                alt="Vital Soruce Logo"
                className="w-12 h-12 sm:w-16 sm:h-16 mr-3 object-contain filter drop-shadow-[0_0_8px_rgba(243,104,18,0.3)]"
              />
              <h2 className="text-white text-2xl sm:text-3xl font-light tracking-widest">
                VITAL SOURCE
              </h2>
            </div>
            <p className="text-gray-300 text-xs sm:text-sm leading-relaxed mb-6 sm:mb-8 max-w-xs">
              Redefining luxury with exquisite gold and diamond craftsmanship. Every creation is a masterpiece.
            </p>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h3 className="text-white text-xs sm:text-sm font-medium tracking-widest mb-4 sm:mb-6 uppercase border-b border-[#f36812]/20 pb-2">
              About vital Source
            </h3>
            <ul className="space-y-3 sm:space-y-4">
              {["Home", "Product",  "About us", "contact",].map((item, index) => (
                <li key={index}>
                  <a
                    href={item}
                    className="text-gray-300 text-xs sm:text-sm hover:text-[#f36812] transition-all duration-300 hover:translate-x-1"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

         

          {/* Contact Information */}
          <div className="lg:col-span-4">
            <h3 className="text-white text-xs sm:text-sm font-medium tracking-widest mb-4 sm:mb-6 uppercase border-b border-[#f36812]/20 pb-2">
              Get in Touch
            </h3>
            <ul className="space-y-4 sm:space-y-5">
              <li className="flex items-start space-x-3">
                <FaMapMarkerAlt className="text-[#f36812] mt-1 text-sm sm:text-base" />
                <span className="text-gray-300 text-xs sm:text-sm leading-relaxed">
                  Richardson TX 75081
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <FaPhone className="text-[#f36812] text-sm sm:text-base" />
                <span className="text-gray-300 text-xs sm:text-sm">+1 (317) 245-6309
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <FaEnvelope className="text-[#f36812] text-sm sm:text-base" />
                <span className="text-gray-300 text-xs sm:text-sm">info@vitalsourcewholesalellc.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Enhanced Divider */}
        <div className="h-[1px] bg-gradient-to-r from-transparent via-[#f36812]/30 to-transparent mb-8" />

        {/* Copyright */}
        <div className="text-center mt-4">
          <p className="text-gray-400 text-xs sm:text-sm">
            © {new Date().getFullYear()} Vital Source. All rights reserved.
          </p>

          {/* 2. Yahan <a> ki jagah <Link> ka use karein */}
          <div className="flex justify-center space-x-4 mt-2">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-white text-xs sm:text-sm underline transition-colors">
              Privacy Policy
            </Link>
            <span className="text-gray-600">|</span>
            <Link to="/terms-conditions" className="text-gray-400 hover:text-white text-xs sm:text-sm underline transition-colors">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>

      {/* Subtle Bottom Gradient */}
      <div className="absolute bottom-0 left-0 w-full h-20 bg-gradient-to-t from-black to-transparent -z-0" />
    </footer>
  );
};

export default Footer;